import { useState } from "react";
import {
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  NavbarLink,
  NavbarActions,
  NavbarToggle,
  NavbarMobileMenu,
  BottomNavbar,
  BottomNavItem,
  NavbarAdaptive,
  Button,
  Badge,
  Input,
  Avatar,
  SegmentedControl,
} from "@one-nexty/components-web";
import { NextyWordmark, NextyBrandLogo } from "@one-nexty/icons";

import { Preview } from "../ui/preview";
import { Section, SubSection } from "../ui/section";
import { SearchIcon } from "../ui/icons";

export function NavbarsSection() {
  const [activeTabStandard, setActiveTabStandard] = useState("produits");
  const [activeTabFloating, setActiveTabFloating] = useState("apercu");
  const [activeBottomTab, setActiveBottomTab] = useState("accueil");
  const [adaptiveActiveTab, setAdaptiveActiveTab] = useState("dashboard");
  const [viewMode, setViewMode] = useState<"desktop" | "mobile">("desktop");

  const adaptiveNavItems = [
    {
      id: "dashboard",
      label: "Accueil",
      icon: (
        <svg className="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
    },
    {
      id: "projets",
      label: "Projets",
      icon: (
        <svg className="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
      ),
      badge: "3",
    },
    {
      id: "messages",
      label: "Messages",
      icon: (
        <svg className="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
      ),
      badge: true,
    },
    {
      id: "parametres",
      label: "Réglages",
      icon: (
        <svg className="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
    },
  ];

  return (
    <Section
      id="navbars"
      eyebrow="Navigation"
      title="Navbars"
      description="En-tête standard, pilule flottante en verre dépoli, dock mobile, et NavbarAdaptive qui bascule de l'un à l'autre selon la largeur."
    >
      {/* ---------------------------------------------------------------- Navbar Standard */}
      <SubSection
        title="Navbar standard"
        hint="Liens, action principale et menu mobile"
      >
        <Preview
          layout="stack"
          className="overflow-hidden rounded-2xl border border-border p-0"
          label="navbar.tsx"
          code={`<Navbar variant="default" sticky>
  <NavbarBrand><Logo /></NavbarBrand>

  <NavbarContent align="center">
    <NavbarItem>
      <NavbarLink active={tab === "apercu"} onClick={() => setTab("apercu")}>
        Aperçu
      </NavbarLink>
    </NavbarItem>
  </NavbarContent>

  <NavbarActions><Button size="sm">Commencer</Button></NavbarActions>
</Navbar>`}
        >
          <Navbar sticky={false} variant="default">
            <NavbarBrand>
              <NextyBrandLogo variant="full" size={20} />
            </NavbarBrand>

            <NavbarContent align="center">
              <NavbarItem>
                <NavbarLink
                  active={activeTabStandard === "produits"}
                  onClick={() => setActiveTabStandard("produits")}
                  href="#navbars"
                >
                  Produits
                </NavbarLink>
              </NavbarItem>
              <NavbarItem>
                <NavbarLink
                  active={activeTabStandard === "tarifs"}
                  onClick={() => setActiveTabStandard("tarifs")}
                  href="#navbars"
                >
                  Tarifs
                </NavbarLink>
              </NavbarItem>
              <NavbarItem>
                <NavbarLink
                  active={activeTabStandard === "docs"}
                  onClick={() => setActiveTabStandard("docs")}
                  href="#navbars"
                >
                  Documentation
                </NavbarLink>
              </NavbarItem>
            </NavbarContent>

            <NavbarActions>
              <div className="hidden sm:block w-40">
                <Input
                  size="sm"
                  placeholder="Recherche..."
                  leading={<SearchIcon className="size-3.5 text-fg-muted" />}
                />
              </div>
              <Button size="sm" variant="primary">
                Connexion
              </Button>
              <NavbarToggle aria-label="Menu mobile" />
            </NavbarActions>

            <NavbarMobileMenu>
              <NavbarLink
                active={activeTabStandard === "produits"}
                onClick={() => setActiveTabStandard("produits")}
                href="#navbars"
              >
                Produits
              </NavbarLink>
              <NavbarLink
                active={activeTabStandard === "tarifs"}
                onClick={() => setActiveTabStandard("tarifs")}
                href="#navbars"
              >
                Tarifs
              </NavbarLink>
              <NavbarLink
                active={activeTabStandard === "docs"}
                onClick={() => setActiveTabStandard("docs")}
                href="#navbars"
              >
                Documentation
              </NavbarLink>
            </NavbarMobileMenu>
          </Navbar>
        </Preview>
      </SubSection>

      <SubSection
        title="Navbar flottante"
        hint="Verre dépoli : le flou est posé une fois, jamais interpolé"
      >
        <Preview
          layout="stack"
          className="rounded-2xl bg-gradient-to-br from-brand/10 via-surface to-accent/10 p-4"
          label="navbar-floating.tsx"
          code={`<Navbar variant="floating">
  <NavbarBrand><Wordmark /></NavbarBrand>
  <NavbarContent align="center">…</NavbarContent>
  <NavbarActions><Avatar name="Arthur" size="sm" /></NavbarActions>
</Navbar>`}
        >
          <Navbar sticky={false} variant="floating">
            <NavbarBrand>
              <NextyWordmark size={18} />
              <Badge tone="brand" className="hidden px-1.5 py-0.5 text-[10px] sm:inline-flex">
                Pro
              </Badge>
            </NavbarBrand>

            <NavbarContent align="center">
              <NavbarItem>
                <NavbarLink
                  active={activeTabFloating === "apercu"}
                  onClick={() => setActiveTabFloating("apercu")}
                  href="#navbars"
                >
                  Aperçu
                </NavbarLink>
              </NavbarItem>
              <NavbarItem>
                <NavbarLink
                  active={activeTabFloating === "features"}
                  onClick={() => setActiveTabFloating("features")}
                  href="#navbars"
                >
                  Fonctionnalités
                </NavbarLink>
              </NavbarItem>
              <NavbarItem>
                <NavbarLink
                  active={activeTabFloating === "tarifs"}
                  onClick={() => setActiveTabFloating("tarifs")}
                  href="#navbars"
                >
                  Offres
                </NavbarLink>
              </NavbarItem>
            </NavbarContent>

            <NavbarActions>
              <Avatar name="Arthur" size="xs" />
              <Button size="sm" variant="secondary" className="rounded-full">
                Essayer
              </Button>
              <NavbarToggle aria-label="Menu flottant mobile" />
            </NavbarActions>

            <NavbarMobileMenu>
              <NavbarLink
                active={activeTabFloating === "apercu"}
                onClick={() => setActiveTabFloating("apercu")}
                href="#navbars"
              >
                Aperçu
              </NavbarLink>
              <NavbarLink
                active={activeTabFloating === "features"}
                onClick={() => setActiveTabFloating("features")}
                href="#navbars"
              >
                Fonctionnalités
              </NavbarLink>
              <NavbarLink
                active={activeTabFloating === "tarifs"}
                onClick={() => setActiveTabFloating("tarifs")}
                href="#navbars"
              >
                Offres
              </NavbarLink>
            </NavbarMobileMenu>
          </Navbar>
        </Preview>
      </SubSection>

      {/* ---------------------------------------------------------------- Bottom Navbar Native */}
      <SubSection
        title="Bottom Navbar"
        hint="Dock tactile, safe areas iOS gérées"
      >
        <Preview layout="stack">
          {/* Simulation smartphone élargie (max-w-md) avec espacement confortable */}
          <div className="w-full max-w-md mx-auto rounded-[32px] border-4 border-border bg-surface shadow-2xl p-5 overflow-hidden relative min-h-[340px] flex flex-col justify-between">
            {/* Haut de simulation smartphone */}
            <div className="flex items-center justify-between pb-3 border-b border-border/40">
              <NextyWordmark size={16} />
              <div className="flex items-center gap-1.5">
                <span className="size-2 rounded-full bg-success" />
                <span className="text-[11px] text-fg-muted">Natif Mobile</span>
              </div>
            </div>

            {/* Contenu simulé */}
            <div className="my-auto py-8 text-center space-y-2">
              <p className="text-sm font-semibold text-fg capitalize">Onglet : {activeBottomTab}</p>
              <p className="text-xs text-fg-muted">
                Démonstration du dock tactile avec retours visuels instantanés
              </p>
            </div>

            {/* Dock BottomNavbar dans la carte smartphone */}
            <BottomNavbar fixed={false} variant="floating">
              <BottomNavItem
                active={activeBottomTab === "accueil"}
                onClick={() => setActiveBottomTab("accueil")}
                label="Accueil"
                icon={
                  <svg className="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                }
              />
              <BottomNavItem
                active={activeBottomTab === "explorer"}
                onClick={() => setActiveBottomTab("explorer")}
                label="Explorer"
                icon={
                  <svg className="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                }
              />
              <BottomNavItem
                active={activeBottomTab === "notifs"}
                onClick={() => setActiveBottomTab("notifs")}
                label="Notifs"
                badge={4}
                icon={
                  <svg className="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                  </svg>
                }
              />
              <BottomNavItem
                active={activeBottomTab === "profil"}
                onClick={() => setActiveBottomTab("profil")}
                label="Profil"
                icon={
                  <svg className="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                }
              />
            </BottomNavbar>
          </div>
        </Preview>
      </SubSection>

      <SubSection
        title="Navbar adaptative"
        hint="Un en-tête sur écran large, un dock inférieur sur smartphone"
      >
        <Preview
          layout="stack"
          className="space-y-4"
          label="navbar-adaptive.tsx"
          code={`<NavbarAdaptive
  brand={<Wordmark />}
  items={items}
  activeId={active}
  onSelect={setActive}
  actions={<Avatar name="Arthur" size="xs" />}
/>`}
        >
          <div className="flex flex-wrap items-center justify-between gap-3 p-3 rounded-xl bg-surface-sunken border border-border">
            <span className="text-xs font-semibold text-fg">Mode d'aperçu</span>
            <SegmentedControl
              size="sm"
              aria-label="Mode de démonstration navbar"
              value={viewMode}
              onValueChange={(val) => setViewMode(val as "desktop" | "mobile")}
              options={[
                { label: "Bureau", value: "desktop" },
                { label: "Smartphone", value: "mobile" },
              ]}
            />
          </div>

          <div
            className={
              viewMode === "mobile"
                ? "w-full max-w-md mx-auto rounded-3xl border-4 border-border bg-surface shadow-xl p-3 min-h-[320px] flex flex-col justify-between overflow-hidden"
                : "w-full rounded-2xl border border-border bg-surface overflow-hidden"
            }
          >
            <NavbarAdaptive
              forceMobileView={viewMode === "mobile"}
              brand={<NextyWordmark size={18} />}
              items={adaptiveNavItems}
              activeId={adaptiveActiveTab}
              onSelect={setAdaptiveActiveTab}
              actions={
                <div className="flex items-center gap-2">
                  <Avatar name="Arthur" size="xs" />
                </div>
              }
            />

            <div className="p-8 text-center my-auto space-y-2">
              <Badge tone="brand">
                {viewMode === "desktop" ? "En-tête supérieur" : "Dock inférieur"}
              </Badge>
              <p className="text-xs text-fg-muted">
                Section : <strong className="text-fg">{adaptiveActiveTab}</strong>
              </p>
            </div>
          </div>
        </Preview>
      </SubSection>
    </Section>
  );
}
